import { InputAdornment, Switch, TextField, Typography } from '@mui/material';
import { get } from 'lodash';

import { useCallback, useRef, useState } from 'react';

import CurrencyField from 'src/components/input/currency-field';
import NumberField from 'src/components/input/number-field';
import { lableSettings } from 'src/config';
import { unformatValue } from 'src/utils/check';
import { convertToBoolean } from 'src/utils/parse';

const InputSetting = ({ setting, handleSave }) => {
  // const settingValue = useSelector((state) => selectSetting(state, setting.key)) || setting.value;
  const [checked, setChecked] = useState(convertToBoolean(setting.value));
  const inputRef = useRef(setting.value);
  const [loadingSave, setLoadingSave] = useState(false);

  const handleSetLoadingSave = useCallback((isLoading) => {
    setLoadingSave(isLoading);
  }, []);

  let InputProps = {};
  if (setting.endAdornment !== false) {
    InputProps = { endAdornment: <InputAdornment position="end">{setting.endAdornment}</InputAdornment> };
  }

  const onSave = useCallback(
    (value) => {
      handleSave({
        value: value,
        key: setting.key,
        valueType: setting.valueType,
        setFieldLoading: handleSetLoadingSave
      });
    },
    [setting]
  );

  return (
    <>
      <Typography color="text.secondary" variant="caption">
        {get(lableSettings, setting.key)}
      </Typography>
      {setting.type === 'currency' && (
        <CurrencyField
          ref={inputRef}
          defaultValue={setting.value}
          variant="standard"
          fullWidth
          size="small"
          // value={inputRef.current}
          //  error={!!errors.setting_value}
          //  helperText={errors?.setting_value?.message}
          InputLabelProps={{ shrink: true }}
          InputProps={InputProps}
          disabled={loadingSave}
          sx={{ minWidth: '136px' }}
          onBlur={(event) => {
            inputRef.current = event.target.value;
            onSave(unformatValue(event.target.value));
          }}
          // onChange={(event) => {
          //   setValue(setting.key, event.target.value);
          // }}
        />
      )}
      {setting.type === 'flag' && (
        <Switch
          onChange={async (event) => {
            setChecked(convertToBoolean(event.target.checked));
            onSave(event.target.checked);
          }}
          checked={checked}
        />
      )}
      {setting.type === 'number' && (
        <NumberField
          ref={inputRef}
          defaultValue={setting.value}
          size="small"
          variant="standard"
          fullWidth
          disabled={loadingSave}
          InputLabelProps={{ shrink: true }}
          InputProps={InputProps}
          sx={{ minWidth: '136px' }}
          onBlur={(event) => {
            inputRef.current = event.target.value;
            onSave(event.target.value);
          }}
        />
      )}

      {setting.type === 'text' && (
        <TextField
          defaultValue={setting.value}
          variant="standard"
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          InputProps={InputProps}
          sx={{ minWidth: '136px' }}
          disabled={loadingSave}
          onBlur={(event) => onSave(event.target.value)}
        />
      )}
    </>
  );
};

export default InputSetting;
